import { buildDeserializer, buildSerializer } from "lib/serializerUtils";

const reportJobSerializerMap = {
  documentStatus: "document_status",
  id: "id",
  status: "status",
  file: "file",
  report: "report",
};

const proceedsRetainedByBillingDocumentSerializerMap = {
  glCode: "gl_code",
  integrationStatus: "integration_status",
  number: "number",
  totalAmountCents: "total_amount_cents",
};

export const serializeMap = {
  billingReference: "billing_reference",
  billingRunId: "billing_run_id",
  created: "created",
  dueDate: "due_date",
  detailsText: "details_text",
  emailIds: "email_ids",
  exportErrors: "export_errors",
  exportWarnings: "export_warnings",
  hasFinancialChanges: "has_financial_changes",
  hasCosmeticChanges: "has_cosmetic_changes",
  id: "id",
  integrationStatus: "integration_status",
  integrationSubtotalCents: "integration_subtotal_cents",
  integrationTotalTaxCents: "integration_total_tax_cents",
  integrationAmountDueCents: "integration_amount_due_cents",
  integrationAmountPaidCents: "integration_amount_paid_cents",
  issuedDate: "issued_date",
  issuerBusinessId: "issuer_business_id",
  invoiceNumber: "invoice_number",
  latestInterestChargeDate: "latest_interest_charge_date",
  lastModified: "last_modified",
  livestockSaleIds: "livestock_sale_ids",
  ledgerEntriesGeneratedDateTime: "ledger_entries_generated_datetime",
  number: "number",
  proceedsRetainedByBillingDocument:
    proceedsRetainedByBillingDocumentSerializerMap,
  hasBeenReversed: "has_been_reversed",
  recipientBusinessId: "recipient_business_id",
  reportJobs: reportJobSerializerMap,
  status: "status",
  totalAmountDollars: "total_amount_dollars",
  totalExTaxAmountDollars: "total_ex_tax_amount_dollars",
  totalTaxAmountDollars: "total_tax_amount_dollars",
  type: "type",
  xeroInvoiceId: "xero_invoice_id",
};

const nestedObjectMap = {
  report_jobs: "reportJobs",
  proceeds_retained_by_billing_document: "proceedsRetainedByBillingDocument",
};

export const serializeBillingDocument = buildSerializer(
  serializeMap,
  "billingDocument",
  nestedObjectMap,
);

export const deserializeBillingDocument = buildDeserializer(
  serializeMap,
  "billingDocument",
  nestedObjectMap,
);

export const serializeRetainedProceedsBillingDocument = buildSerializer(
  proceedsRetainedByBillingDocumentSerializerMap,
  "billingDocument",
);

export const deserializeRetainedProceedsBillingDocument = buildDeserializer(
  proceedsRetainedByBillingDocumentSerializerMap,
  "retainedProceedsBillingDocument",
);
